// src/context/CookieConsentContext.js
import React, { createContext, useState, useEffect } from 'react';

const CookieConsentContext = createContext();

export const CookieConsentProvider = ({ children }) => {
  const [cookieAccepted, setCookieAccepted] = useState(false);
  const [cookieRejected, setCookieRejected] = useState(false);
  const COOKIE_EXPIRY_DAYS = 30;

  // Check localStorage on mount and when storage changes
  const checkCookieConsent = () => {
    const consent = localStorage.getItem('cookieAccepted');
    const consentTimestamp = localStorage.getItem('cookieAcceptedTimestamp');
    const rejected = localStorage.getItem('cookieRejected');

    if (rejected) {
      setCookieRejected(true);
      return;
    }
    if (consent && consentTimestamp) {
      const currentTime = new Date().getTime();
      const expiryTime = new Date(Number(consentTimestamp)).getTime() + COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000;

      if (currentTime < expiryTime) {
        setCookieAccepted(true);
      } else {
        localStorage.removeItem('cookieAccepted');
        localStorage.removeItem('cookieAcceptedTimestamp');
      }
    }
  };

  useEffect(() => {
    checkCookieConsent();

    // Listen for storage changes (when login happens)
    window.addEventListener('storage', checkCookieConsent);
    
    // Custom event listener for same-window updates
    window.addEventListener('cookieConsentChanged', checkCookieConsent);

    return () => {
      window.removeEventListener('storage', checkCookieConsent);
      window.removeEventListener('cookieConsentChanged', checkCookieConsent);
    };
  }, []);

  const handleAcceptCookies = () => {
    const currentTime = new Date().getTime();
    localStorage.setItem('cookieAccepted', 'true');
    localStorage.setItem('cookieAcceptedTimestamp', currentTime.toString());
    setCookieAccepted(true);
  };
  const handleRejectCookies = () => {
    localStorage.setItem('cookieRejected', 'true');
    setCookieAccepted(true);
  };

  const resetCookieConsent = () => {
    setCookieRejected(true);
  };

  return (
    <CookieConsentContext.Provider value={{ cookieAccepted, cookieRejected, handleAcceptCookies, handleRejectCookies, resetCookieConsent }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => React.useContext(CookieConsentContext);
